import Vue from "vue";
import Router from "vue-router";


Vue.use(Router);

const router = new Router({
  mode: "history",
  // Base should match your deployment path, usually "/"
  base: process.env.BASE_URL, 
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("./components/Login/login"),
    },
    {
      path: "/admin",
      component: () => import("./components/adminDash2/dashBoard"), 
      meta: { requiresAuth: true },
      children: [
        {
          path: "", // This is the default child for /admin
          name: "board",
          component: () => import("./components/board/board"),
        },
        {
          path: "userlist",
          name: "userlist",
          component: () => import("./components/userList/list"),
        },
        {
          path: "userview", 
          name: "userview",
          component: () => import("./components/userList/userView"),
        },
        {
          path: "uploaddetail",
          name: "uploaddetail",
          component: () => import("./components/userList/userUploadDetails"),
        },
        {
          path: "privacy", 
          name: "privacy", // Fixed typo "privay"
          component: () => import("./components/privacyPolicy/policy"),
        },
        {
          path: "reports",
          name: "reports",
          component: () => import("./components/Reports/reports"),
        },
      ],
    },
    { path: "*", component: () => import("./common/404") }
  ],
});



router.beforeEach((to, from, next) => {
  // Check localStorage directly for the most reliable auth check
  const isAuthenticated = !!localStorage.getItem("token");
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Not logged in? Go to login
      next({ name: 'login' });
    } else {
      // Logged in? Proceed
      next();
    }
  } else {
    // If trying to access login page while already logged in
    if (isAuthenticated && to.name === 'login') {
      next({ name: 'board' });
    } else {
      next();
    }
  }
});

export default router;